import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';

import BoostRecord from 'records/boost';
import CampaignRecord from 'records/campaign';
import CategoryRecord from 'records/category';
import CompanyRecord from 'records/company';
import EmailSettingsRecord from 'records/emailSettings';
import FollowUpRecord from 'records/followUp';
import InvoiceRecord from 'records/invoice';
import KeywordRecord from 'records/keyword';
import ListingRecord from 'records/listing';
import MeRecord from 'records/me';
import MediumRecord from 'records/medium';
import NotificationRecord from 'records/notification';
import OrderRecord from 'records/order';
import PageRecord from 'records/page';
import PlanRecord from 'records/plan';
import ProductRecord from 'records/product';
import PromotionRecord from 'records/promotion';
import ServiceRecord from 'records/service';
import SubscriptionRecord from 'records/subscription';

export const BoostPropType = PropTypes.instanceOf(BoostRecord);
export const CampaignPropType = PropTypes.instanceOf(CampaignRecord);
export const CampaignsPropType = ImmutablePropTypes.listOf(CampaignRecord);
export const CompanyPropType = PropTypes.instanceOf(CompanyRecord);
export const CategoryPropType = PropTypes.instanceOf(CategoryRecord);
export const CategoriesPropType = ImmutablePropTypes.listOf(CategoryRecord);
export const EmailSettingsPropType = PropTypes.instanceOf(EmailSettingsRecord);
export const FollowUpPropType = PropTypes.instanceOf(FollowUpRecord);
export const InvoicePropType = PropTypes.instanceOf(InvoiceRecord);
export const KeywordPropType = PropTypes.instanceOf(KeywordRecord);
export const KeywordsPropType = ImmutablePropTypes.listOf(KeywordRecord);
export const ListingPropType = PropTypes.instanceOf(ListingRecord);
export const MePropType = PropTypes.instanceOf(MeRecord);
export const MediaPropType = ImmutablePropTypes.listOf(MediumRecord);
export const MediumPropType = PropTypes.instanceOf(MediumRecord);
export const NotificationPropType = PropTypes.instanceOf(NotificationRecord);
export const OrderPropType = PropTypes.instanceOf(OrderRecord);
export const OrdersPropType = ImmutablePropTypes.listOf(OrderRecord);
export const PagePropType = PropTypes.instanceOf(PageRecord);
export const PlanPropType = PropTypes.instanceOf(PlanRecord);
export const PlansPropType = ImmutablePropTypes.listOf(PlanRecord);
export const ProductPropType = PropTypes.instanceOf(ProductRecord);
export const ProductsPropType = ImmutablePropTypes.listOf(ProductRecord);
export const PromotionPropType = PropTypes.instanceOf(PromotionRecord);
export const ServicePropType = PropTypes.instanceOf(ServiceRecord);
export const ServicesPropType = ImmutablePropTypes.listOf(ServiceRecord);
export const SubscriptionPropType = PropTypes.instanceOf(SubscriptionRecord);



// WEBPACK FOOTER //
// ./src/proptypes/records.js